module.exports = __webpack_public_path__ + "static/empty-state-d43e3929577026b6dd1e23e8518bee4c.png";